document.addEventListener( 'DOMContentLoaded', () => {
    document.querySelectorAll( '.wp-block-embed-vimeo, .wp-block-embed-youtube' )?.forEach( ( container ) => {
        container.querySelector( '.video-play-button' ).addEventListener( 'click', () => {
            container.classList.add( 'wp-block-embed--active' );
            const iframe = container.querySelector( 'iframe' );
            iframe.src = iframe.dataset.src + '&autoplay=1';
        }, {once: true} );
    } );
} );
